module.exports = __webpack_public_path__ + "static/Joy@2x.858ffbfe.png";